var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledDataset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9043 3.08984C1.9043 4.0332 3.55664 4.69531 6 4.69531C8.44336 4.69531 10.0957 4.0332 10.0957 3.08984C10.0957 2.10547 8.45508 1.41992 6 1.41992C3.54492 1.41992 1.9043 2.10547 1.9043 3.08984ZM6 8.32227C3.82617 8.32227 2.19727 7.83008 0.960938 6.78125V3.08984C0.960938 1.61328 2.97656 0.59375 6 0.59375C9.02344 0.59375 11.0391 1.61328 11.0391 3.08984V6.78125C9.80273 7.83008 8.17383 8.32227 6 8.32227ZM0.960938 10.1797V7.80078C2.26758 8.76172 3.89062 9.20703 6 9.20703C8.10938 9.20703 9.73242 8.76172 11.0391 7.80078V10.1797C11.0391 11.7969 9.00586 12.9395 6 12.9395C2.99414 12.9395 0.960938 11.7969 0.960938 10.1797Z",
    fill: "#3779E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDataset);
export default __webpack_public_path__ + "static/media/filled-dataset.834e911daf022ade1aaabd7b4bc4c61d.svg";
export { ForwardRef as ReactComponent };